/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

// Local Definitions

import {
  Page,
  Title,
} from '@pareto-engineering/design-system'

import './styles.scss'

import { ConversionFormButton } from 'modules/components'

const baseClassName = styleNames.base

const componentClassName = 'section-cta'

/**
 * This is the component description.
 */
const SectionCTA = ({
  id,
  className:userClassName,
  style,
  heading,
  subtitle,
  buttonText,
}) => (
  <Page.Section
    id={id}
    className={[
      baseClassName,
      componentClassName,
      userClassName,
    ]
      .filter((e) => e)
      .join(' ')}
    style={style}
    isSpaced
  >
    <div className="span-8 md-start-4 md-span-8">
      <Title
        heading={heading}
        headingAs="p"
        headingClassName="h1"
        subtitle={subtitle}
        subtitleClassName="s2 subtitle"
      />
      <ConversionFormButton
        color="interactive"
        isGradient
        isSpaced
      >
        {buttonText}
      </ConversionFormButton>
    </div>
  </Page.Section>
)

SectionCTA.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   * The text to display in the CTA button
   */
  buttonText:PropTypes.string,

  /**
   * The heading of the cta
   */
  heading:PropTypes.string.isRequired,

  /**
   * The subtitle of the cta
   */
  subtitle:PropTypes.string.isRequired,
}

SectionCTA.defaultProps = {
  id        :'cta',
  buttonText:'Get started',
}

export default SectionCTA
